export default Vue => {
  Vue.component("v-pdf", () => import("./v-pdf.vue"));
};
